import { Alert } from "legion-ui";
import React from "react";

export default function AlertExample() {
  return (
    <>
      <Alert
        style={{ marginBottom: 15 }}
        title="Info title"
        desc="Interactively monetize corporate alignments and fully tested niche markets."
      />
      <Alert
        style={{ marginBottom: 15 }}
        title="Warning title"
        desc="Interactively monetize corporate alignments and fully tested niche markets."
        variant="warning"
      />
      <Alert
        style={{ marginBottom: 15 }}
        title="Error title"
        desc="Interactively monetize corporate alignments and fully tested niche markets."
        variant="error"
      />
      <Alert
        title="Success title"
        desc="Interactively monetize corporate alignments and fully tested niche markets."
        variant="success"
      />
    </>
  );
}